{
  "serverErrors": {
    "requestError": "Request returned an error."
  },
  "modifyViewModal": {
    "errors": {
      "nameRequired": "A name is required"
    }
  },
  "query": {
    "timeinput_placeholder": "Jump to timeframe"
  },
  "live": {
    "text": "Live",
    "tooltip": "Toggle Live"
  },
  "viewMenu": {
    "everything": "Everything",
    "thisOrg": "This Organization",
    "federatedSearch": "Federated Search",
    "unsaved": "Unsaved View",
    "save": "Save view changes",
    "noChanges": "No changes to be saved.",
    "noFilterQuery": "No changes to be saved, try applying a Filter or a Search first.",
    "update": "Update this View’s Filter and Search settings.",
    "saveAsNew": "Save as new view",
    "saveAsNewDescription": "Save a state of your Filter and/or Search settings.",
    "saveAsNewDuplicate": "Duplicate this View as a new View.",
    "edit": "Edit view properties",
    "editDescription": "Rename this View or set description and line format.",
    "delete": "Delete this view",
    "deleteDescription": "Delete {{name}} and any attached Alerts associated with this View.",
    "editAlert": "Edit alert",
    "editAlertDescription": "Edit or add Alert Channels to this View.",
    "detachAlerts": "Detach alert",
    "detachAlertsDescription": "Detach Alert from this View.",
    "attachAlert": "Attach an alert",
    "attachAlertDescription": "Attach an Alert to this View.",
    "attachAlertUnavailable": "Upgrade your plan to enable alerts.",
    "attachAlertDisabled": "Save the Filters or Search as a View before attaching an Alert.",
    "exportLines": "Export lines",
    "exportLinesDescription": "Export lines with the current Filter and Search settings.",
    "exportLinesUnavailable": "Upgrade your plan to export lines."
  },
  "filters": {
    "menuLabel": "Filters",
    "filtersApplied": "Filters Applied",
    "orgs": "Organizations",
    "orgs_plural": "{{count}} Organizations",
    "tags": "Tags",
    "tags_plural": "{{count}} Tags",
    "sources": "Sources",
    "sources_plural": "{{count}} Sources",
    "apps": "Apps",
    "apps_plural": "{{count}} Apps",
    "levels": "Levels",
    "levels_plural": "{{count}} Levels",
    "deleteGroup": "Delete this group?",
    "filtersAppearHint": "Your applied filters appear here.",
    "saveAsGroupHint": "Use the <strong>SAVE AS GROUP</strong> link to create a group from your selected filters."
  },
  "timeFramePresets": {
    "jumpToTime": "Jump to Time",
    "info": "Navigate through your logs faster by jumping to a specific time within your retention period.",
    "absolute": "Type in an absolute time like",
    "relative": "or relative time like",
    "rangeStart": "You can also specify a time range to scope your logs like",
    "rangeEnd": "yesterday 10am to yesterday 11am",
    "threeDaysAgo": "3 days ago",
    "anHourAgo": "an hour ago",
    "searchHelp": "Search Syntax Tips"
  },
  "navigation": {
    "addToFavorites": "Add to Favorites",
    "removeFromFavorites": "Remove from Favorites"
  },
  "timeline": {
    "enableTimeline": "Upgrade your plan to enable Timeline!",
    "upgradePlan": "Upgrade Plan",
    "tryAgain": "Try again?",
    "contactSupport": "Contact support",
    "scopeIn": "Scope in",
    "scopeTo": "Scope to:",
    "jumpTo": "Jump to",
    "toggle": "Toggle timeline ({{symbol}} + ')",
    "timeline": "Timeline",
    "reset": "Reset",
    "timelineTip": "A visualization of your log volume trends for the current search criteria and time scale.",
    "lines": "lines",
    "Lines": "Lines",
    "fullRetention": "Full retention",
    "timeScale": "Time scale:",
    "chooseScale": "Choose a scale...",
    "windowHeight": "We're unable to show your timeline at this window height, please resize your window.",
    "freeAccount": "You're currently on a plan without search retention. Upgrade your plan to enable timeline.",
    "loadingError": "There was an error loading the data.",
    "noData": "No data found.",
    "noConnection": "No connection. Unable to load timeline."
  },
  "searchMessage": {
    "stillSearching": "Still Searching...",
    "noResultFound1": "Still Searching... No results found between {{ from }} and {{ to }}.",
    "noResultFound2": "We searched from <strong>{{ from }}</strong> to <strong>{{ to }}</strong> and could not find any lines matching your search criteria."
  },
  "controlBar": {
    "changeContrast": "Change Contrast",
    "setLight": "Set Light Theme",
    "setDark": "Set Dark Theme"
  },
  "upgradeCallout": {
    "title": "Sadly you are currently on a plan that does not contain any search retention. :'‑(",
    "upgradeButton": "Upgrade your plan",
    "toPreserveLogs": " to preserve your history!"
  }
}
